
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graphic-design",
      function () {
        return require("private-next-pages/graphic-design.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graphic-design"])
      });
    }
  